import { language } from 'curvy';

export const english: language.TranslationDefinition = {
	locale: 'en-us',
	translations: {
		"PUNJENJE.TITLE": "Shelf stocking",
		"PUNJENJE.PREV_WEEK": "Previous week",
		"PUNJENJE.NEXT_WEEK": "Next week",
		"PUNJENJE.TODAY": "Today",
		"PUNJENJE.NEW_PLAN": "New plan",
		"PUNJENJE.EXPORT": "Export (.xlsx)",
		"PUNJENJE.VIEW.MONTH": "Month",
		"PUNJENJE.VIEW.WEEK": "Week",
		"PUNJENJE.VIEW.DAY": "Day",
		"PUNJENJE.EMPTY": "No visits for the selected filters.",
		"PUNJENJE.LOADING": "Loading…",
		"PUNJENJE.NO_TIME": "—",

		"PUNJENJE.FILTER.SUPPLIER": "Supplier",
		"PUNJENJE.FILTER.STORE": "Store",
		"PUNJENJE.FILTER.TYPE": "Visit type",
		"PUNJENJE.FILTER.CLEAR": "Clear filters",

		"PUNJENJE.STATUS.PLANNED": "Planned",
		"PUNJENJE.STATUS.IN_PROGRESS": "In progress",
		"PUNJENJE.STATUS.DONE": "Done",
		"PUNJENJE.STATUS.NO_SHOW": "No show",

		"PUNJENJE.TYPE.SHELF_STOCKING": "Shelf stocking",
		"PUNJENJE.TYPE.SALES_VISIT": "Sales visit",
		"PUNJENJE.TYPE.EXTRA_DISPLAY_STOCKING": "Extra display stocking",
		"PUNJENJE.TYPE.ASSORTMENT_CONTROL": "Assortment control",
		"PUNJENJE.TYPE.OTHER": "Other",

		"PUNJENJE.TYPE_SHORT.SHELF_STOCKING": "PP",
		"PUNJENJE.TYPE_SHORT.SALES_VISIT": "PR",
		"PUNJENJE.TYPE_SHORT.EXTRA_DISPLAY_STOCKING": "PDI",
		"PUNJENJE.TYPE_SHORT.ASSORTMENT_CONTROL": "KA",
		"PUNJENJE.TYPE_SHORT.OTHER": "OS",

		"PUNJENJE.ADH": "ADH",
		"PUNJENJE.CARD.CIN": "No.",

		"PUNJENJE.CLOSE": "Close",
		"PUNJENJE.DETAIL.STORE": "Store",
		"PUNJENJE.DETAIL.DATE": "Date",
		"PUNJENJE.DETAIL.TIME": "Planned time",
		"PUNJENJE.DETAIL.TYPES": "Visit types",
		"PUNJENJE.DETAIL.NOTE": "Note",
		"PUNJENJE.DETAIL.COMPLETION_NOTE": "Completion note",
		"PUNJENJE.DETAIL.PLANNED_WORKERS": "Planned workers",
		"PUNJENJE.DETAIL.VISITS": "Visits",
		"PUNJENJE.DETAIL.WORK_ITEMS": "Work done",
		"PUNJENJE.DETAIL.PRESENT_WORKERS": "Present workers",
		"PUNJENJE.DETAIL.TOTAL": "Total",
		"PUNJENJE.DETAIL.CHECK_IN": "Check-in",
		"PUNJENJE.DETAIL.CHECK_OUT": "Check-out",
		"PUNJENJE.DETAIL.HOURS": "h",
		"PUNJENJE.DETAIL.WORKERS_UNIT": "workers",
		"PUNJENJE.DETAIL.ADHOC_VISIT": "Ad-hoc visit",
		"PUNJENJE.DETAIL.NO_VISITS": "No visits yet.",
		"PUNJENJE.EDIT": "Edit",
		"PUNJENJE.DELETE_BTN": "Delete",
		"PUNJENJE.NO_SHOW_BTN": "Mark: no show",
		"PUNJENJE.DELETE.TITLE": "Delete plan",
		"PUNJENJE.DELETE.MSG": "Are you sure you want to delete this plan?",
		"PUNJENJE.NO_SHOW.TITLE": "Mark as no show",
		"PUNJENJE.NO_SHOW.MSG": "Mark this plan as 'no show'? This action is irreversible.",

		"PUNJENJE.FORM.NEW": "New plan",
		"PUNJENJE.FORM.EDIT": "Edit plan",
		"PUNJENJE.FORM.MODE_SINGLE": "Single entry",
		"PUNJENJE.FORM.MODE_BATCH": "Weekly / monthly",
		"PUNJENJE.FORM.SUPPLIER": "Supplier",
		"PUNJENJE.FORM.STORE": "Store",
		"PUNJENJE.FORM.DATE": "Visit date",
		"PUNJENJE.FORM.TIME": "Planned time",
		"PUNJENJE.FORM.TYPES": "Visit types",
		"PUNJENJE.FORM.NOTE": "Note",
		"PUNJENJE.FORM.WORKERS": "Planned workers",
		"PUNJENJE.FORM.WORKERS_PICK_SUPPLIER": "Select a supplier first to choose its workers.",
		"PUNJENJE.FORM.WORKERS_EDIT_LOCKED": "Editing planned workers isn't supported yet.",
		"PUNJENJE.FORM.ADD_TERM": "Add term",
		"PUNJENJE.FORM.ADD_WEEK": "Add week",
		"PUNJENJE.FORM.ADD_MONTH": "Add month",
		"PUNJENJE.FORM.WEEK_START": "Start date",
		"PUNJENJE.FORM.NO_ROWS": "Add at least one term.",
		"PUNJENJE.FORM.BATCH_HINT": "Quick fill: pick a start date → \"Add week\" (7 days) or \"Add month\" (4 weeks) from that date. Or add single terms. The plan = the terms listed below.",
		"PUNJENJE.FORM.TYPE_REQUIRED": "Select at least one visit type.",
		"PUNJENJE.FORM.LOCKED": "Plan is locked — a visit already exists, so editing is disabled.",
		"PUNJENJE.FORM.LOCKED_NO_SHOW": "Plan is marked 'No show', so editing is disabled.",
		"PUNJENJE.FORM.LOCKED_DONE": "Plan is marked 'Done', so editing is disabled.",
		"PUNJENJE.FORM.LOCKED_IN_PROGRESS": "Plan is marked 'In progress', so editing is disabled.",
	}
};

export const croatian: language.TranslationDefinition = {
	locale: 'hr-hr',
	translations: {
		"PUNJENJE.TITLE": "Punjenje polica",
		"PUNJENJE.PREV_WEEK": "Prethodni tjedan",
		"PUNJENJE.NEXT_WEEK": "Sljedeći tjedan",
		"PUNJENJE.TODAY": "Danas",
		"PUNJENJE.NEW_PLAN": "Novi plan",
		"PUNJENJE.EXPORT": "Export (.xlsx)",
		"PUNJENJE.VIEW.MONTH": "Mjesec",
		"PUNJENJE.VIEW.WEEK": "Tjedan",
		"PUNJENJE.VIEW.DAY": "Dan",
		"PUNJENJE.EMPTY": "Nema posjeta za odabrane filtere.",
		"PUNJENJE.LOADING": "Učitavanje…",
		"PUNJENJE.NO_TIME": "—",

		"PUNJENJE.FILTER.SUPPLIER": "Dobavljač",
		"PUNJENJE.FILTER.STORE": "Prodavaonica",
		"PUNJENJE.FILTER.TYPE": "Tip posjeta",
		"PUNJENJE.FILTER.CLEAR": "Očisti filtere",

		"PUNJENJE.STATUS.PLANNED": "Planiran",
		"PUNJENJE.STATUS.IN_PROGRESS": "U tijeku",
		"PUNJENJE.STATUS.DONE": "Završeno",
		"PUNJENJE.STATUS.NO_SHOW": "Nije došao",

		"PUNJENJE.TYPE.SHELF_STOCKING": "Punjenje polica",
		"PUNJENJE.TYPE.SALES_VISIT": "Prodajni posjet",
		"PUNJENJE.TYPE.EXTRA_DISPLAY_STOCKING": "Punjenje dodatnih izlaganja",
		"PUNJENJE.TYPE.ASSORTMENT_CONTROL": "Kontrola asortimana",
		"PUNJENJE.TYPE.OTHER": "Ostalo",

		"PUNJENJE.TYPE_SHORT.SHELF_STOCKING": "PP",
		"PUNJENJE.TYPE_SHORT.SALES_VISIT": "PR",
		"PUNJENJE.TYPE_SHORT.EXTRA_DISPLAY_STOCKING": "PDI",
		"PUNJENJE.TYPE_SHORT.ASSORTMENT_CONTROL": "KA",
		"PUNJENJE.TYPE_SHORT.OTHER": "OS",

		"PUNJENJE.ADH": "ADH",
		"PUNJENJE.CARD.CIN": "br.",

		"PUNJENJE.CLOSE": "Zatvori",
		"PUNJENJE.DETAIL.STORE": "Prodavaonica",
		"PUNJENJE.DETAIL.DATE": "Datum",
		"PUNJENJE.DETAIL.TIME": "Planirani sat",
		"PUNJENJE.DETAIL.TYPES": "Tipovi posjeta",
		"PUNJENJE.DETAIL.NOTE": "Napomena",
		"PUNJENJE.DETAIL.COMPLETION_NOTE": "Napomena završetka",
		"PUNJENJE.DETAIL.PLANNED_WORKERS": "Planirani radnici",
		"PUNJENJE.DETAIL.VISITS": "Posjeti",
		"PUNJENJE.DETAIL.WORK_ITEMS": "Obavljeni posao",
		"PUNJENJE.DETAIL.PRESENT_WORKERS": "Prisutni radnici",
		"PUNJENJE.DETAIL.TOTAL": "Ukupno",
		"PUNJENJE.DETAIL.CHECK_IN": "Potvrda dolaska",
		"PUNJENJE.DETAIL.CHECK_OUT": "Potvrda završetka",
		"PUNJENJE.DETAIL.HOURS": "h",
		"PUNJENJE.DETAIL.WORKERS_UNIT": "radnika",
		"PUNJENJE.DETAIL.ADHOC_VISIT": "Ad-hoc posjet",
		"PUNJENJE.DETAIL.NO_VISITS": "Još nema posjeta.",
		"PUNJENJE.EDIT": "Uredi",
		"PUNJENJE.DELETE_BTN": "Obriši",
		"PUNJENJE.NO_SHOW_BTN": "Označi: nije došao",
		"PUNJENJE.DELETE.TITLE": "Brisanje plana",
		"PUNJENJE.DELETE.MSG": "Jeste li sigurni da želite obrisati ovaj plan?",
		"PUNJENJE.NO_SHOW.TITLE": "Označi „nije došao\"",
		"PUNJENJE.NO_SHOW.MSG": "Označiti ovaj plan kao „nije došao\"? Radnja je nepovratna.",

		"PUNJENJE.FORM.NEW": "Novi plan",
		"PUNJENJE.FORM.EDIT": "Izmjena plana",
		"PUNJENJE.FORM.MODE_SINGLE": "Pojedinačni unos",
		"PUNJENJE.FORM.MODE_BATCH": "Tjedni / mjesečni",
		"PUNJENJE.FORM.SUPPLIER": "Dobavljač",
		"PUNJENJE.FORM.STORE": "Prodavaonica",
		"PUNJENJE.FORM.DATE": "Datum posjeta",
		"PUNJENJE.FORM.TIME": "Planirani sat",
		"PUNJENJE.FORM.TYPES": "Tipovi posjeta",
		"PUNJENJE.FORM.NOTE": "Napomena",
		"PUNJENJE.FORM.WORKERS": "Planirani radnici",
		"PUNJENJE.FORM.WORKERS_PICK_SUPPLIER": "Prvo odaberite dobavljača da biste birali njegove radnike.",
		"PUNJENJE.FORM.WORKERS_EDIT_LOCKED": "Izmjena planiranih radnika trenutno nije podržana.",
		"PUNJENJE.FORM.ADD_TERM": "Dodaj termin",
		"PUNJENJE.FORM.ADD_WEEK": "Dodaj tjedan",
		"PUNJENJE.FORM.ADD_MONTH": "Dodaj mjesec",
		"PUNJENJE.FORM.WEEK_START": "Datum početka",
		"PUNJENJE.FORM.NO_ROWS": "Dodajte barem jedan termin.",
		"PUNJENJE.FORM.BATCH_HINT": "Brzi unos: odaberi datum početka → \"Dodaj tjedan\" (7 dana) ili \"Dodaj mjesec\" (4 tjedna) od tog datuma. Ili pojedinačno \"Dodaj termin\". Plan = termini izlistani ispod.",
		"PUNJENJE.FORM.TYPE_REQUIRED": "Odaberite barem jedan tip posjeta.",
		"PUNJENJE.FORM.LOCKED": "Plan je zaključan — postoji posjet, pa uređivanje nije moguće.",
		"PUNJENJE.FORM.LOCKED_NO_SHOW": "Plan je označen kao 'Nije došao', pa uređivanje nije moguće.",
		"PUNJENJE.FORM.LOCKED_DONE": "Plan je označen kao 'Završeno', pa uređivanje nije moguće.",
		"PUNJENJE.FORM.LOCKED_IN_PROGRESS": "Plan je označen kao 'U tijeku', pa uređivanje nije moguće.",
	}
};

export const shelf_filler_translations = [english, croatian];
